import React from "react";
import "./style.scss";

export default function NewsTicker({ data = [] }) {
  let ticketItems = [];

  let repeat = 0;
  if (data.length > 0) {
    repeat = Math.ceil(15 / data.length);
  }

  for (let i = 0; i < repeat; i++) {
    data.forEach((item) => {
      ticketItems.push(
        <div key={`news-item-${i + 1}`} className="ticker-item">
          {item.link !== "" ? (
            <a href={item.link.length > 0 && item.link} target="__blank" dangerouslySetInnerHTML={{ __html: item.text }}></a>
          ) : (
            <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
          )}
        </div>
      );
    });
  }

  return (
    <div>
      <div className="tcontainer">
        <div className="ticker-wrap">
          <div className="ticker-move">{ticketItems}</div>
        </div>
      </div>
    </div>
  );
}
